<template>
  <div>
    <!-- BEGIN: Plans Details -->
    <div id="basic-non-sticky-notification-packet-plan-view" class="toastify-content hidden flex flex-col sm:flex-row">
      <div class="font-medium text-primary-3" v-if="page_data.error">{{ page_data.error }}</div>
    </div>
    <div id="plan-details-modal" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xxl">
        <div class="modal-content">
          <div class="modal-header">
            <div class="flex items-center justify-between w-full">
              <h2 class="font-medium text-base mr-auto">Packet Planning Details</h2>
              <div>
                <button class="btn btn-primary mr-3 btn-sm"
                  v-if="[1].includes(user_details.user_role) || ([2, 8].includes(user_details.user_role) && page_data.packet_details.status == 2 && page_data.packet_details.process_id != null && [3, 4, 5, 9, 11].includes(page_data.packet_details.process_type)) || ([4, 6, 5].includes(user_details.user_role) && page_data.packet_details.status == 2 && page_data.packet_details.employee_id == user_details.account_id && page_data.packet_details.employee_role == user_details.user_role && [3, 4, 5, 9, 11].includes(page_data.packet_details.process_type))"
                  @click="addNewPlanning(page_data.pack_id)">Add Planning</button>
                <button class="btn btn-primary mr-3 btn-sm" v-if="page_data.plan_details.length > 0"
                  v-print="'#planning-details'">Print</button>
                <button class="btn btn-primary btn-sm mr-3" @click="SetImportDetails"
                  v-if="[1].includes(user_details.user_role) || ([2, 8].includes(user_details.user_role) && page_data.packet_details.status == 2 && page_data.packet_details.process_id != null && [3, 4, 5, 9, 11].includes(page_data.packet_details.process_type)) || ([4, 6, 5].includes(user_details.user_role) && page_data.packet_details.status == 2 && page_data.packet_details.employee_id == user_details.account_id && [3, 4, 5, 9, 11].includes(page_data.packet_details.process_type) && page_data.packet_details.employee_role == user_details.user_role)">Import
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body p-3" id="planning-details">

            <div class="flex flex-wrap">

              <p class="font-medium text-base mr-auto"><b>Packet Number : </b>{{ page_data.pack_code }} {{
                page_data.packet_details.vepari_no ? ' ( ' + page_data.packet_details.vepari_no + ' ) ' : '' }} <span
                  v-if="page_data.cosing_value">( {{ page_data.cosing_value }} $ )</span></p>
              <p class="font-medium text-base mr-auto" v-if="page_data.packet_details.final_plan_date"><b>Final Plan
                  Date
                  : </b>{{ page_data.packet_details.final_plan_date ? page_data.packet_details.final_plan_date : '' }}
              </p>
            </div>
            <div class="mt-3">
              <div class="w-full max-w-full overflow-x-auto relative">

                <table class="mt-3 w-full border-2">
                  <thead>
                    <tr class="bg-slate-50 text-xs">
                      <th class="th">No</th>
                      <th class="th">Makeable Wt (Ct)</th>
                      <th class="th">Polish Wt (Ct)</th>
                      <th class="th">Pieces</th>
                      <th class="th">Planner / Checker / Job Party</th>
                      <th class="th">Total Plan Value ($)</th>
                      <th class="th">Plan Date</th>
                      <th class="th">Status</th>
                      <th class="th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-for="(plan, index) in page_data.plan_details" :key="index">
                    <tr class="border-b bg-gray-100 dark:bg-dark-1">
                      <th class="td">{{ index + 1 }}</th>
                      <th class="td">{{ plan.total_weight }}</th>
                      <th class="td">{{ plan.total_pwt }}</th>
                      <th class="td">{{ plan.pieces }}</th>
                      <th class="td">{{
                        [1, 2, 8].includes(plan.planner_role) ? (plan.manager_first_name + ' ' + plan.manager_last_name) :
                          ([5, 6].includes(plan.planner_role) ? (plan.planner_first_name + ' ' + plan.planner_last_name) :
                            ([4].includes(plan.planner_role) ? (plan.party_first_name + ' ' + plan.party_last_name) : "-")) }}
                      </th>
                      <th class="td">{{
                        plan.total_value }}
                        <span v-if="page_data.cosing_value">
                          <span v-if="plan.total_value - page_data.cosing_value > 0" class="text-theme-9">
                            <ArrowUpIcon class="h-6 w-6 p-1" /> ( {{ parseFloat(100 * (plan.total_value -
                              page_data.cosing_value)
                              / page_data.cosing_value).toFixed(2) }} % )
                          </span>
                          <span v-else class="text-theme-6">
                            <ArrowDownIcon class="h-6 w-6 p-1" /> ( {{ parseFloat(100 * (page_data.cosing_value -
                              plan.total_value) / page_data.cosing_value).toFixed(2) }} % )
                          </span>
                        </span>
                      </th>
                      <th class="td">{{ plan.created_at }}</th>
                      <th class="td"><span
                          class="text-theme-6" v-if="plan.status == 0">{{ plan.status == 0 ? 'Active' : 'Selected'
                          }}</span><span class="text-theme-9" v-else>{{ plan.status == 0 ? 'Active' : 'Selected' }}</span>
                      </th>
                      <th class="td">
                        <div v-if="[1, 2, 8, 3].includes(user_details.user_role)">
                          <div class="flex justify-center items-center">
                            <a class="btn btn-primary btn-sm flex items-center mr-3 p-1" href="javascript:;"
                              v-if="page_data.packet_details.is_makeabled == false && plan.planner_id == user_details.account_id && plan.planner_role == user_details.user_role && plan.planner_role == user_details.user_role"
                              @click="updatePlanDetails(plan.id, plan.packet_id, plan.cr_weight, plan.stone)">
                              <CheckSquareIcon class="w-4 h-4 mr-1" />
                              Edit
                            </a>
                            <a class="btn btn-primary btn-sm flex items-center mr-3 p-1" href="javascript:;"
                              v-if="page_data.packet_details.is_makeabled == false && plan.status == 0"
                              @click="finalPlanDone(plan.id, plan.packet_id)">
                              <CheckSquareIcon class="w-4 h-4 mr-1" />
                              Final
                            </a>
                            <a class="btn btn-danger btn-sm flex items-center mr-3 p-1" href="javascript:;"
                              v-if="page_data.packet_details.is_makeabled == false && plan.status == 1"
                              @click="removefinalPlanDone(plan.id, plan.packet_id)">
                              <CheckSquareIcon class="w-4 h-4 mr-1" />
                              Remove Final
                            </a>
                            <a class="btn btn-danger btn-sm flex items-center mr-2 p-1" href="javascript:;"
                              v-if="page_data.packet_details.is_makeabled == false && plan.planner_id == user_details.account_id && plan.planner_role == user_details.user_role"
                              @click="deletePlanDetails(plan.id, plan.packet_id)">
                              <TrashIcon class="w-4 h-4 mr-1" />

                            </a>
                            <a class="btn btn-primary btn-sm flex items-center mr-2 p-1" href="javascript:;"
                              v-print="'#single_plan_' + index">
                              <PrinterIcon class="w-4 h-4 mr-1" />
                            </a>
                          </div>
                        </div>
                        <div v-if="[6].includes(user_details.user_role)">

                          <div class="flex justify-center items-center">
                            <a class="btn btn-primary flex items-center mr-2 p-1" href="javascript:;"
                              v-if="plan.planner_id == user_details.account_id && plan.planner_role == user_details.user_role"
                              @click="updatePlanDetails(plan.id, plan.packet_id, plan.cr_weight, plan.stone)">
                              <CheckSquareIcon class="w-4 h-4 mr-1" />
                              Edit
                            </a>
                            <a class="btn btn-primary flex items-center mr-2 p-1" href="javascript:;"
                              v-if="plan.status == 0" @click="finalPlanDone(plan.id, plan.packet_id)">
                              <CheckSquareIcon class="w-4 h-4 mr-1" />
                              Final
                            </a>
                            <a class="btn btn-danger flex items-center mr-2 p-1" href="javascript:;"
                              v-if="plan.status == 1" @click="removefinalPlanDone(plan.id, plan.packet_id)">
                              <CheckSquareIcon class="w-4 h-4 mr-1" />
                              Remove Final
                            </a>
                            <a class="btn btn-danger flex items-center mr-2 p-1" href="javascript:;"
                              v-if="plan.planner_id == user_details.account_id && plan.planner_role == user_details.user_role"
                              @click="deletePlanDetails(plan.id, plan.packet_id)">
                              <TrashIcon class="w-4 h-4 mr-1" />

                            </a>
                            <a class="btn btn-primary flex items-center mr-2 p-1" href="javascript:;"
                              v-print="'#single_plan_' + index">
                              <PrinterIcon class="w-4 h-4 mr-1" />

                            </a>
                          </div>
                        </div>
                        <div v-if="[4, 5].includes(user_details.user_role)">

                          <div class="flex justify-center items-center">
                            <a class="btn btn-primary flex items-center mr-2 p-1" href="javascript:;"
                              v-if="plan.planner_id == user_details.account_id && plan.planner_role == user_details.user_role"
                              @click="updatePlanDetails(plan.id, plan.packet_id, plan.cr_weight, plan.stone)">
                              <CheckSquareIcon class="w-4 h-4 mr-1" />
                              Edit
                            </a>
                            <a class="btn btn-danger flex items-center mr-2 p-1" href="javascript:;"
                              v-if="plan.planner_id == user_details.account_id && plan.planner_role == user_details.user_role"
                              @click="deletePlanDetails(plan.id, plan.packet_id)">
                              <TrashIcon class="w-4 h-4 mr-1" />

                            </a>
                            <a class="btn btn-primary flex items-center mr-2 p-1" href="javascript:;"
                              v-print="'#single_plan_' + index">
                              <PrinterIcon class="w-4 h-4 mr-1" />

                            </a>
                          </div>
                        </div>
                      </th>
                    </tr>
                    <tr>
                      <td colspan="9">

                        <div class=" max-w-full overflow-x-auto relative">

                          <table class="my-3 w-full border-2" :id="'single_plan_' + index">
                            <thead>
                              <tr class="text-center">
                                <th class="th-group">No</th>
                                <th class="th-group">Makeable Wt (Ct)</th>
                                <th class="th-group">Polish Wt (Ct)</th>
                                <th class="th-group">Shp</th>
                                <th class="th-group">Clr</th>
                                <th class="th-group">Prt</th>
                                <th class="th-group">Cut</th>
                                <th class="th-group">PL</th>
                                <th class="th-group">Symm</th>
                                <th class="th-group">Fluc</th>
                                <th class="th-group">Stn</th>
                                <th class="th-group">Ratio</th>
                                <th class="th-group">Tabl</th>
                                <th class="th-group">Height</th>
                                <th class="th-group">Repo</th>
                                <th class="th-group">Back</th>
                                <th class="th-group">Value</th>
                                <th class="th-group">Total Value</th>
                                <th class="th-group">Lab</th>
                                <th class="th-group">Lab Rate</th>
                                <th class="th-group">Total Amount</th>
                                <th class="th-group">Status</th>
                                <th class="th-group">Urgent</th>
                                <th class="th-group">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(plan_det, index) in plan.plan_details" :key="index"
                                class="border hover:bg-gray-200 p-0 cursor-pointer">
                                <td class="td">{{ index + 1 }}</td>
                                <td class="td">{{ plan_det.weight }}</td>
                                <td class="td">{{ plan_det.polish_weight
                                  }}
                                </td>
                                <td class="td">{{ plan_det.shape }}</td>
                                <td class="td">{{ plan_det.color }}</td>
                                <td class="td">{{ plan_det.purity }}</td>
                                <td class="td">{{ plan_det.cut }}</td>
                                <td class="td">{{ plan_det.polish }}</td>
                                <td class="td">{{ plan_det.symmetry }}
                                </td>
                                <td class="td">{{ plan_det.fluerocent }}
                                </td>
                                <td class="td">{{ plan_det.stone }}</td>
                                <td class="td">{{ plan_det.ratio }}</td>
                                <td class="td">{{ plan_det.tabl }}</td>
                                <td class="td">{{ plan_det.height }}</td>
                                <td class="td">{{ plan_det.r_rate }}</td>
                                <td class="td">{{ plan_det.discount }}
                                </td>
                                <td class="td">{{ parseFloat(plan_det.value).toFixed(2) }}</td>
                                <td class="td">{{ plan_det.total_value }}</td>
                                <td class="td">{{ plan_det.lab }}</td>
                                <td class="td">{{ plan_det.lab_rate }}</td>
                                <td class="td">{{ plan_det.total_amount }}</td>
                                <td class="td">
                                  <label for="update-profile-form-6" class="form-label">
                                    <span v-if="plan_det.status == 0" class="text-theme-11 font-bold">Pending</span>
                                    <span v-if="plan_det.status == 1" class="text-theme-9 font-bold">Generated</span>
                                  </label>
                                </td>
                                <td class="py-2 border-b text-xs lg:text-md text-center border-r">
                                  <a class="" :class="plan_det.urgent == 1 ? 'text-primary-4' : 'text-primary-3'"
                                    href="javascript:;">
                                    {{ plan_det.urgent == 1 ? 'Urgent' : 'N/A' }}
                                  </a>
                                </td>
                                <td class="py-2 border-b text-xs lg:text-md text-center border-r">
                                  <a class="btn btn-sm btn-link flex items-center mx-2 p-1 px-0"
                                    :class="plan_det.urgent == 1 ? 'btn-danger' : 'btn-primary'" href="javascript:;"
                                    @click="updateUrgentStatus(plan_det)">
                                    {{ plan_det.urgent == 1 ? 'Remove' : 'Mark Urgent' }}
                                  </a>
                                </td>
                              </tr>

                            </tbody>
                          </table>
                        </div>

                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Plan Details -->
  </div>

</template>
<script setup>
import { BASE_URL } from "@/constants/config";
import store from "@/store";
import { inject, onMounted, provide, reactive, ref, computed } from "vue";
import Toastify from 'toastify-js'

const emit = defineEmits(['updatePlanDetails', 'SetImportDetails', 'addNewPlanning', 'focutScan'])

const swal = inject('$swal')

const user_details = computed(() => store.state.user.currentUser)

const page_data = reactive({
  pack_code: "",
  pack_id: "",
  stone: "",
  pack_weight: "",
  error: "",
  packet_details: [],
  plan_details: [],
  cosing_value: 0,
})


const getPacketPlans = (id) => {

  let params = {
    packet_id: window.btoa(id)
  }
  cash('#plan-details-modal').modal('show')
  axios({
    url: 'api/plan/get_packet_plans_details',
    method: 'post',
    baseURL: BASE_URL,
    data: params,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
    config: { headers: { 'Accept': 'application/json' } }
  }).then((res) => {

    const packet = res.data.packet_item

    page_data.pack_id        = packet.id
    page_data.stone          = packet.stone
    page_data.pack_weight    = packet.cr_weight
    page_data.packet_details = packet
    page_data.plan_details   = res.data.items
    page_data.pack_code      = packet.number

    // ---------------- COSTING LOGIC ----------------
      if (!packet.owner_value) return

      const ownerValue = Number(packet.owner_value)
      const majuriRate = Number(packet.majuri_rate)
      const weight     = Number(packet.weight)
      const margin     = Number(packet.margin_percent)

      const majuriAmount =
        packet.majuri_type === 1
          ? (ownerValue * majuriRate) / 100
          : weight * majuriRate

      const baseCosting = ownerValue + majuriAmount
      const marginAmount = (baseCosting * margin) / 100

      page_data.cosing_value = (baseCosting + marginAmount).toFixed(2)
  })
}

function updatePlanDetails(id, pack_id, weight, stone) {

  emit('updatePlanDetails', {
    id: id,
    pack_id: pack_id,
    weight: weight,
    stone: stone
  })

}

const SetImportDetails = () => {

  emit('SetImportDetails', {

    number: page_data.packet_details.number,
    vepari_no: page_data.packet_details.vepari_no,
    id: page_data.packet_details.id,
  })
}

const finalPlanDone = (plan_id, packet_id) => {

  swal({
    title: "Are you sure?",
    text: "You are make a final Plan!",
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Accept",
    showLoaderOnConfirm: true,
    cancelButtonText: "Cancel",

    allowOutsideClick: () => !$Swal.isLoading()
  }).then(result => {
    if (result.isConfirmed) {
      let params = {
        packet_id: window.btoa(packet_id),
        plan_id: window.btoa(plan_id)
      }
      axios({
        url: 'api/plan/final_plan_packet_detail',
        method: 'post',
        baseURL: BASE_URL,
        data: params,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        config: { headers: { 'Accept': 'application/json' } }
      }).then((res) => {
        page_data.message = res.data.success
        getPacketPlans(packet_id)
        setTimeout(() => {
          basicNonStickyNotificationPacketSuccess()
        }, 100)
        setTimeout(() => {
          page_data.message = ''
        }, 3000);
      })
    }
  });

}
const removefinalPlanDone = (plan_id, packet_id) => {

  swal({
    title: "Are you sure?",
    text: "You wan't to Cancle Final Plan!",
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Remove",
    showLoaderOnConfirm: true,
    cancelButtonText: "Cancel",

    allowOutsideClick: () => !$Swal.isLoading()
  }).then(result => {
    if (result.isConfirmed) {
      let params = {
        packet_id: window.btoa(packet_id),
        plan_id: window.btoa(plan_id)
      }
      axios({
        url: 'api/plan/remove_final_plan_packet_detail',
        method: 'post',
        baseURL: BASE_URL,
        data: params,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        config: { headers: { 'Accept': 'application/json' } }
      }).then((res) => {
        page_data.message = res.data.success
        getPacketPlans(packet_id)
        setTimeout(() => {
          basicNonStickyNotificationPacketSuccess()
        }, 100)
        setTimeout(() => {
          page_data.message = ''
        }, 3000);
      })
    }
  });

}

const deletePlanDetails = (id, packet_id) => {

  swal({
    title: "Are you sure?",
    text: "You are about to Delete Plan!",
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Reject",
    showLoaderOnConfirm: true,
    cancelButtonText: "Cancel",

    allowOutsideClick: () => swal.isLoading()
  }).then(result => {
    if (result.isConfirmed) {

      const params = {
        plan_id: (id != '' ? window.btoa(id) : ''),
      }

      let promise_url = 'api/plan/delete_plan'
      let promise = axios({
        url: promise_url,
        method: "POST",
        data: params,
        baseURL: BASE_URL,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),

        },
        config: {
          headers: {
            Accept: "application/json"
          }
        }
      });
      return promise
        .then(result => result.data)
        .then(data => {

          if (data.status == 'error') {
            swal('Warning', data.message, 'warning');
          } else {
            swal('Success', data.message, 'success');
            getPacketPlans(packet_id)
            initTabulator()
          }
        })
        .catch(_error => {
          swal('Error', 'Something went wrong.', 'error');
        });

    }
  });
}


const updateUrgentStatus = (item) => {

  swal({
    title: "Are you sure?",
    text: "You wan't to mark as " + (item.urgent == 1 ? 'not urgent' : 'Urgent'),
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Update",
    showLoaderOnConfirm: true,
    cancelButtonText: "Cancel",

    allowOutsideClick: () => !$Swal.isLoading()
  }).then(result => {
    if (result.isConfirmed) {
      let params = {
        id: window.btoa(item.id),
        status: (item.urgent ? 2 : 1)
      }
      axios({
        url: 'api/plan/update_plan_urgent_status',
        method: 'post',
        baseURL: BASE_URL,
        data: params,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        config: { headers: { 'Accept': 'application/json' } }
      }).then((res) => {
        getPacketPlans(item.packet_id)
      })
    }
  });

}

const addNewPlanning = (id) => {
  emit('addNewPlanning', page_data.packet_details)
}

const checkadd = (search) => {
  if (search) {
    const params = {
      pkt_no: window.btoa(search)
    }
    axios({
      url: 'api/plan/get_planner_packet_id',
      method: 'post',
      baseURL: BASE_URL,
      data: params,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      config: { headers: { 'Accept': 'application/json' } }
    }).then((res) => {
      let packet_id = res.data.packet
      page_data.pack_code = page_data.search

      cash('#plan-details-modal').modal('show')

      const packet = res.data.packet_item

      page_data.pack_id        = packet.id
      page_data.stone          = packet.stone
      page_data.pack_weight    = packet.cr_weight
      page_data.packet_details = packet
      page_data.plan_details   = res.data.items
      page_data.pack_code      = packet.number

      // ---------------- COSTING LOGIC ----------------
      if (!packet.owner_value) return

      const ownerValue = Number(packet.owner_value)
      const majuriRate = Number(packet.majuri_rate)
      const weight     = Number(packet.weight)
      const margin     = Number(packet.margin_percent)

      const majuriAmount =
        packet.majuri_type === 1
          ? (ownerValue * majuriRate) / 100
          : weight * majuriRate

      const baseCosting = ownerValue + majuriAmount
      const marginAmount = (baseCosting * margin) / 100

      page_data.cosing_value = (baseCosting + marginAmount).toFixed(2)

      emit('focutScan', false)
    }).catch((err) => {
      page_data.error = err.response.data.error
      setTimeout(() => {
        basicNonStickyNotificationPacket()
      }, 100)

      emit('focutScan', true)

      setTimeout(() => {
        page_data.error = ''
      }, 3000);

    })
  }
}


const getPlnaDetails = (id, number) => {
  page_data.pack_code = number
  getPacketPlans(id)
}

const basicNonStickyNotificationPacket = () => {
  Toastify({
    node: cash('#basic-non-sticky-notification-packet-plan-view')
      .clone()
      .removeClass('hidden')[0],
    duration: 3000,
    newWindow: true,
    close: true,
    gravity: 'top',
    position: 'right',
    stopOnFocus: true
  }).showToast()
}

defineExpose({
  getPlnaDetails,
  checkadd,
  getPacketPlans
})
</script>

<style scoped>
.th {
  border: 1px solid #d1d5db;
  padding: 6px;
  font-size: 12px;
  font-weight: 600;
  background: #f1f5f9;
  white-space: nowrap;
}

.th-group {
  border: 1px solid #d1d5db;
  padding: 6px;
  font-size: 12px;
  font-weight: 700;
  background: #e2e8f0;
  text-align: center;
}

.td {
  border: 1px solid #d1d5db;
  padding: 4px;
  white-space: nowrap;
}

.input {
  width: 100px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
}

.select {
  width: 90px;              /* FIXED WIDTH */
  max-width: 90px;
  padding: 4px;
  border: 1px solid #d1d5db;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>

